// extracted by css-extract-rspack-plugin
export default {"root":"organisation-area-content_root__U2XKH"};